/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Rigved's Portfolio",
  description:
    "A detail-oriented engineer passionate about leveraging advanced technology to solve real-world problems, with a proven track record of innovation and impact.",
  og: {
    title: "Rigved Shirvalkar Portfolio",
    type: "website",
    url: "http://rigvedrs.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Rigved Shirvalkar",
  logo_name: "RigvedShirvalkar",
  nickname: "rigvedrs",
  subTitle:
    "A detail-oriented engineer passionate about leveraging advanced technology to solve real-world problems, with a proven track record of innovation and impact.",
  resumeLink:
    "https://drive.google.com/file/d/1bXRknv_h-XI_3CQ3SGPteGODtvEb7YvI/view?usp=sharing",
  portfolio_repository: "https://github.com/rigvedrs/Portfolio",
  githubProfile: "https://github.com/rigvedrs",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/rigvedrs",
  // linkedin: "https://www.linkedin.com/in/rigved-shirvalkar-88710b138/",
  // gmail: "rigvedshirvalkar98@gmail.com",
  // gitlab: "https://gitlab.com/rigvedshirvalkar98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/rigved_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/rigvedrs",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/rigvedrs/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:rigved.s@nyu.edu",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/Rigved02",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Artificial Intelligence",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Experience of working and researching in Computer Vision and NLP domains",
        "⚡ Developed multiple POCs using deep learning models for clients",
        "⚡ Experience of working with PyTorch, Tensorflow and Keras",
        "⚡ PS: I love PyTorch!",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Gen AI Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Worked on Gen AI solutions using LLMs for production tasks",
        "⚡ Developed a custom RAG pipeline with Llama Index and its fully custom backend using FastAPI",
        "⚡ Fine-tuned Large Language Models and embedding models for downstream tasks",
        "⚡ Integrated additional custom features like document tracking, local OCR support, etc",
      ],
      softwareSkills: [
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "devicon:fastapi-wordmark",
          style: {
            color: "#009688",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Hugging Face",
          fontAwesomeClassname: "logos:hugging-face-icon",
          style: {
            color: "#20232a",
          },
        },
        {
          skillName: "Streamlit",
          fontAwesomeClassname: "simple-icons:streamlit",
          style: {
            color: "#FF4B33",
          },
        },
        {
          skillName: "Langchain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "devicon:redis-wordmark",
          style: {
            color: "#DC382D",
          },
        },
      ],
    },
    {
      title: "MLOps and Cloud Infrastructure",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Extensive experience with multiple cloud platforms for ML infrastructure and deployment",
        "⚡ Expertise in deploying and scaling deep learning models using cloud-native technologies like Kubernetes and Docker",
        "⚡ Designed and implemented CI/CD pipelines using Argo Workflows for automated model training and deployment",
        "⚡ Built MLOps pipelines incorporating MLflow for experiment tracking, Ray Tune for distributed hyperparameter optimization",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        // Argo Workflows
        {
          skillName: "Argo Workflows",
          fontAwesomeClassname: "devicon:argocd-wordmark",
          style: {
            color: "#000000",
          },
        },
        //MLFlow
        {
          skillName: "MLFlow",
          fontAwesomeClassname: "simple-icons:mlflow",
          style: {
            color: "#000000",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://rigvedrs.github.io/education",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://rigvedrs.github.io/education",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://rigvedrs.github.io/education",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://rigvedrs.github.io/education",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "rigvedrs.github.io/education",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "New York University",
      subtitle: "M.S. in Computer Engineering",
      logo_path: "NYU_Logo.png",
      alt_name: "NYU",
      duration: "2024 - Present",
      descriptions: [
        "⚡ Pursuing advanced coursework in Machine Learning, Computer Vision, Big Data, Systems Engineering, MLOps, and Computer Systems Architecture",
        "⚡ Maintaining a 4.0 GPA and recipient of merit-based scholarship",
        "⚡ Focusing on cutting-edge AI/ML technologies and their practical applications in engineering systems",
      ],
      website_link: "https://www.nyu.edu/",
    },
    {
      title: "Amrita School of Engineering",
      subtitle: "B.Tech. in Electronics and Computer Engineering",
      logo_path: "Amrita_Logo.png",
      alt_name: "Amrita School of Engineering",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ Studied basic software engineering subjects like DSA, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing as well",
        "⚡ Graduated with a CGPA of 8.67/10 with distinction",
      ],
      website_link: "https://www.amrita.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "Coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/979C9WULCVB2",
      alt_name: "Coursera",
      color_code: "#1F70C199",
    },
    {
      title:
        "Improving Deep Neural Networks: Hyperparameter Tuning, Regularization and Optimization",
      subtitle: "- Andrew Ng",
      logo_path: "Coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/V7F7J8ZHJ9Y5",
      alt_name: "Coursera",
      color_code: "#1F70C199",
    },
    {
      title: "Structuring Machine Learning Projects",
      subtitle: "- Andrew Ng",
      logo_path: "Coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/B8PGZW32F4X2",
      alt_name: "Coursera",
      color_code: "#1F70C199",
    },
    {
      title: "Introduction to Artificial Intelligence with Python",
      subtitle: "- CS50",
      logo_path: "Edx_Logo.png",
      certificate_link:
        "https://github.com/rigvedrs/Courses/tree/main/CS50's%20Introduction%20to%20Artificial%20Intelligence%20with%20Python",
      alt_name: "EdX",
      // very light gray
      color_code: "#E6E6E6",
    },
    {
      title: "Data Science: Machine Learning",
      subtitle: "- HarvardX PH125.8x",
      logo_path: "Edx_Logo.png",
      certificate_link: "https://github.com/rigvedrs/Courses/tree/main",
      alt_name: "EdX",
      color_code: "#E6E6E6",
    },
    {
      title: "Deep Learning with Python and PyTorch",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://github.com/rigvedrs/Courses/tree/main/IBM%20Deep%20Learning%20with%20Python%20and%20PyTorch",
      alt_name: "IBM",
      color_code: "#E6E6E6",
    },
    {
      title: "How Diffusion Models Work",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/98aef889-6097-4368-881b-59a8a76f35ac",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Evaluating and Debugging Generative AI",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/b1da69a2-cf55-4937-89a2-6614ca34904d",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Reinforcement Learning from Human Feedback",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/cf9a70bf-cfb9-4311-9f6e-36f98c1d6a5a",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Vector Databases: from Embeddings to Applications",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/855cbd66-2da8-4bc7-b416-bed6b42c87bb",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Functions, Tools and Agents with LangChain",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/20939ad0-3b2e-40e7-8130-59e47a7d5ca1",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Understanding and Applying Text Embeddings",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/cc3bd4ab-08c0-45e3-8eb2-2d19f39e5e52",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Quality and Safety for LLM Applications",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/e56dab39-634e-4447-8b84-e15e544f2a18",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Building and Evaluating Advanced RAG",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/c013237b-d0bb-4423-8e8a-757fe5127813",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Large Language Models with Semantic Search",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/7cf0bfd7-f5c3-4d07-a30f-42b23e6447ff",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Building Generative AI Applications with Gradio",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/680721da-5113-4b30-845f-d7b4548fe562",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Finetuning Large Language Models",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/2a024f72-9a98-42f2-b2f3-31b8bac366fd",
      alt_name: "deeplearning.ai",
      color_code: "#00000033",
    },
    {
      title: "Introduction to Deep Learning Using PyTorch",
      subtitle: "- Udacity",
      logo_path: "Udacity_Logo.png",
      certificate_link: "https://github.com/rigvedrs/Udacity-DL-Course",
      alt_name: "Udacity",
      color_code: "#00000",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  // subtitle: "Work, Internship and Volunteership",
  description:
    "Computer Engineering graduate student at NYU specializing in AI/ML development and MLOps. Experienced in building production-grade AI systems including RAG pipelines, computer vision solutions, and scalable data processing systems. Currently working at NYU IT, with prior experience in researchand open-source communities.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Experiences",
      work: true,
      experiences: [
        {
          title: "AI Developer",
          company: "NYU IT",
          company_url: "https://www.nyu.edu/",
          logo_path: "NYU_Logo.png",
          duration: "Dec 2024 - Present",
          location: "New York, NY",
          description:
            "• Architected and implemented a production-grade RAG pipeline supporting multiple LLM integrations (Claude, Grok, Hugging Face) with custom token tracking and cost analytics\n• Engineered embedding solutions using Portkey APIs with intelligent rate-limiting and exponential backoff strategies, improving processing time by 80% for large documents\n• Developed comprehensive usage analytics dashboard with role-based access controls for students and professors, enabling real-time cost tracking and token management\n• Containerized the application using Docker and deployed to cloud infrastructure, ensuring consistent functionality across development and production environments",
          color: "#702483",
        },
        {
          title: "AI Intern",
          company: "Comsense Technologies",
          company_url: "https://www.comsensetechnologies.com/",
          logo_path: "comsense_logo.png",
          duration: "Feb 2024 - Jun 2024",
          location: "New York, NY",
          description:
            "• Engineered a production-grade RAG pipeline, fine-tuning embedding models that improved hit rate by 22%, while benchmarking multiple vector databases to optimize query performance\n• Fine-tuned large language models using LoRA for specific business use cases and implemented comprehensive guardrails to ensure business-compliant outputs, resulting in 75% improvement in domain-specific response accuracy\n• Built scalable data pipeline using FastAPI, implementing asynchronous processing, reducing system latency by 40%\n• Performed data analysis to find optimum train route paths using genetic algorithm, for transit system optimization\n• Designed and implemented comprehensive data parsing, ensuring 95% extraction accuracy for unstructured data\n• Delivered multiple production-ready Gen AI solutions for enterprise clients, utilizing AWS SageMaker for efficient model deployment, resulting in seamless adoption and 30% reduction in implementation costs",
          color: "#0879bf",
        },
        {
          title: "Open Source Contributor",
          company: "Red Hen Lab",
          company_url: "https://github.com/",
          logo_path: "redhen_logo.png",
          duration: "Jun 2023 - Nov 2023",
          location: "Remote",
          description:
            "• Led development of a Speech Gesture Recognition pipeline for Christian art analysis, implementing pose detection transformers and custom YOLO models to identify and classify meaningful gestures with 95%+ accuracy\n• Designed and implemented multi-stage computer vision system integrating person detection, keypoint extraction, and pose classification to automate iconographic analysis of Christian artwork\n• Created end-to-end deep learning pipeline that successfully detected and classified prayer poses, blessing gestures, and symbolic objects in historic artwork using PyTorch and YOLO architectures\n• Developed user-friendly Streamlit interface for art analysis tool that combined multiple deep learning models to identify historic figures (Mary, Jesus) and interpret their gestures and poses in Christian iconography\n• Collaborated with mentors to refine project scope and methodology, pivoting from traditional computer vision approaches to transformer-based models to achieve superior performance on artistic imagery",
          color: "#000000",
        },
        {
          title: "Full Stack Developer",
          company: "Traboda",
          company_url: "https://traboda.com/",
          logo_path: "traboda_logo.jpeg",
          duration: "Mar 2021 - Jul 2021",
          location: "Remote",
          description:
            "• Designed UI components using ReactJS for the challenge dashboard, improving mobile usability for 40% of users\n• Created form validation for challenge submission pages, decreasing invalid submissions by 25%\n• Fixed 12+ UI bugs across different screen sizes and devices, achieving 95% cross-browser compatibility\n• Implemented sorting and filtering functionality for the leaderboard page, reducing data load times by 20%\n• Added backend logging functionality to track and analyze user behavior, helping identify 3 performance bottlenecks\n• Configured Django caching for leaderboard data, reducing database load by 40% during peak competition periods\n• Implemented 3 RESTful API endpoints using Django REST Framework for challenge submission and verification, processing 500+ daily requests",
          color: "#fc1f20",
        },
      ],
    },
    // {
    //   title: "Internships",
    //   experiences: [
    //     {
    //       title: "Machine Learning Intern",
    //       company: "TikTok Inc.",
    //       company_url: "https://www.tiktok.com/en/",
    //       logo_path: "tiktok_logo.png",
    //       duration: "May 2022 - Aug 2022",
    //       location: "San Francisco, USA",
    //       description:
    //         "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Data Science Research Intern",
    //       company: "Delhivery Pvt. Ltd.",
    //       company_url: "https://www.delhivery.com/",
    //       logo_path: "delhivery_logo.png",
    //       duration: "May 2019 - Sept 2019",
    //       location: "Gurgaon, Haryana",
    //       description:
    //         "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
    //       color: "#ee3c26",
    //     },
    //     {
    //       title: "Data Science Intern",
    //       company: "Intel Indexer LLC",
    //       company_url:
    //         "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
    //       logo_path: "intel_logo.jpg",
    //       duration: "Nov 2018 - Dec 2018",
    //       location: "Work From Home",
    //       description:
    //         "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
    //       color: "#0071C5",
    //     },
    //   ],
    // },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Explore ML Facilitator",
    //       company: "Google",
    //       company_url: "https://about.google/",
    //       logo_path: "google_logo.png",
    //       duration: "June 2019 - April 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Microsoft Student Partner",
    //       company: "Microsoft",
    //       company_url: "https://www.microsoft.com/",
    //       logo_path: "microsoft_logo.png",
    //       duration: "Aug 2019 - May 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Mozilla Campus Captain",
    //       company: "Mozilla",
    //       company_url: "https://www.mozilla.org/",
    //       logo_path: "mozilla_logo.png",
    //       duration: "Oct 2019 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Developer Students Club Member",
    //       company: "DSC IIITDM Kurnool",
    //       company_url:
    //         "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
    //       logo_path: "dsc_logo.png",
    //       duration: "Jan 2018 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    //       color: "#0C9D58",
    //     },
    //     {
    //       title: "Developer Program Member",
    //       company: "Github",
    //       company_url: "https://github.com/",
    //       logo_path: "github_logo.png",
    //       duration: "July 2019 - PRESENT",
    //       location: "Work From Home",
    //       description:
    //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
    //       color: "#181717",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects span a diverse range of cutting-edge technologies, from building AI-driven pipelines to deploying web and mobile applications. I excel in creating innovative solutions in computer vision, NLP, and GenAI, with a focus on research, interpretability, and real-world impact.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Research and Blogs.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "bias-mitigation-image-classification",
      name:
        "Mitigating Bias in Image Classification: Pretraining on Diverse Data for Improved Generalization",
      createdAt: "2023-01-01T00:00:00Z",
      description:
        "Paper published in 7th International Conference on Electronics, Materials Engineering & Nano-Technology (IEMENTech)",
      url: "https://ieeexplore.ieee.org/abstract/document/10423435",
    },
    {
      id: "pneumonia-detection-resnet",
      name:
        "Enhancing Pneumonia Detection Accuracy Through ResNet-Based Deep Learning Models and Ensemble Techniques: A Study Using Chest X-Ray Images",
      createdAt: "2024-01-01T00:00:00Z",
      description:
        "Paper published in Springer through 7th International Conference on Smart Trends in Computing and Communications",
      url: "https://link.springer.com/chapter/10.1007/978-981-97-1313-4_3",
    },
    {
      id: "red-hen-labs-blog",
      name:
        "My blog on my journey at Red Hen Labs on Speech Gesture Recognition In Christian Art images",
      createdAt: "2023-08-01T00:00:00Z",
      description: "Blog published in Medium",
      url:
        "https://medium.com/@rigvedrs/speech-gesture-recognition-in-christian-art-images-f19712104d7f",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Connect With Me",
    profile_image_path: "rigved_animated.png",
    description:
      "You can reach out to me through any of the following platforms. I am always open to interesting conversations and collaboration.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.rigvedshirvalkar.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "New York, USA",
    locality: "Brooklyn",
    country: "USA",
    region: "New York",
    postalCode: "11201",
    streetAddress: "Manhatta",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/QzvtMU5Fr7w8SV96A",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
